import { strategicCareerPlanningModule } from './modules/strategic-career-planning';
import { professionalNetworkingModule } from './modules/professional-networking';
import { leadershipDevelopmentModule } from './modules/leadership-development';
import { organizationalNavigationModule } from './modules/organizational-navigation';

export const CAREER_ADVANCEMENT_COURSES = [
  {
    id: 'career-advancement',
    title: 'Career Advancement & Leadership Excellence',
    description: 'Accelerate your career growth through strategic planning, networking, and leadership development.',
    level: 'intermediate',
    totalDuration: '3 hours',
    image: '/api/placeholder/400/300',
    prerequisites: ['Professional work experience'],
    learningOutcomes: [
      'Create effective career development plans and goals',
      'Build professional networks and mentoring relationships',
      'Develop leadership and management skills',
      'Navigate organizational structures and advancement opportunities'
    ],
    modules: [
      strategicCareerPlanningModule,
      professionalNetworkingModule,
      leadershipDevelopmentModule,
      organizationalNavigationModule
    ]
  }
];